import type { BlokProps } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokQoute } from "@/storyblok";
import styles from "./QouteBlok.module.css";

export const QouteBlok = ({ blok }: BlokProps<BlokQoute>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<p className={styles.root}>{blok.text}</p>
		</BlokWrap>
	);
};
